import React from "react"
import InlineMultiSelectDropdown from "../../molecules/InlineMultiSelectDropdown.molecule"

const teamMemberFilterTemplate = ({
  options,
  teamMembers,
  teamMemberFilterOptionsRef,
  showNoOption = true,
  noOptionLabel = "Sin integrante",
  loading = false,
}) => {
  teamMemberFilterOptionsRef.current = options
  const formattedOptions = teamMembers
    .map((tm) => ({
      label: `${tm.nameTag} - ${tm.name} ${tm.lastName}`,
      value: tm.id,
      active: tm.active,
    }))
    .reduce(
      (acc, curr) => {
        if (curr.active) {
          acc[0].items.push(curr)
        } else {
          acc[1].items.push(curr)
        }
        return acc
      },
      [
        {
          active: "true",
          items: [],
        },
        {
          active: "false",
          items: [],
        },
      ]
    )
    .filter((o) => o.items.length > 0)
  if (showNoOption) {
    formattedOptions.unshift({
      active: "",
      items: [
        {
          label: noOptionLabel,
          value: undefined,
        },
      ],
    })
  }

  return (
    <InlineMultiSelectDropdown
      value={options.value || []}
      options={formattedOptions}
      onChange={(value) => {
        options.filterCallback(value)
      }}
      className="pending-historical-tasks-team-member-filter"
      optionLabel="label"
      optionValue="value"
      optionGroupLabel="active"
      optionGroupChildren="items"
      optionGroupTemplate={(option) => {
        if (option.active === "true") {
          return <div>Activo</div>
        }
        if (option.active === "false") {
          return <div>Inactivo</div>
        }
        return null
      }}
      hasSearchBar
      initiallyExpanded
      hideToggleButton
      placeholder="Filtrar integrante"
      emptyFilterMessage="Sin resultados ¿Seguro que trabaja aquí?"
      panelClassName="max-w-23rem"
      itemTemplate={(option) => (
        <div
          className="overflow-hidden white-space-nowrap text-overflow-ellipsis"
          title={option.label}
        >
          {option.label}
        </div>
      )}
      selectedItemTemplate={(option) => {
        return (
          <div>
            {
              formattedOptions
                .flatMap((o) => o.items)
                .find((o) => o.value === option.value)?.label
            }
          </div>
        )
      }}
      maxSelectedLabels={1}
      selectedItemsLabel={`${options.value?.length} integrantes seleccionados`}
      loading={loading}
    />
  )
}

export default teamMemberFilterTemplate
